<div [appStoryblok]="_editable">
  <div class="container-xl gx-lg-5 gx-4 pt-5">
    <div class="row">
      <div
        class="col my-x d-flex d-flex-row align-items-center justify-content-between"
      >
        <h3 *ngIf="title" class="mb-0">
          {{ title }}
        </h3>
        <div class="toggler d-none d-sm-flex">
          <a routerLinkActive="active" [routerLink]="['/collections/all']"
            >All</a
          >
          <a
            routerLinkActive="active"
            [routerLink]="['/collections/reusable-cups']"
            >Cups</a
          >
          <a
            routerLinkActive="active"
            [routerLink]="['/collections/drink-bottles']"
            >Bottles</a
          >
          <a
            routerLinkActive="active"
            [routerLink]="['/collections/accessories']"
            >Accessories</a
          >
        </div>
      </div>
    </div>
    <div class="row border-bottom mx-1 mb-3"></div>
  </div>
  <div
    class="container-xl gx-0 gx-lg-4 collection pb-5"
    *ngIf="products.length > 0"
  >
    <app-carousel [options]="options">
      <div class="px-3 border-end d-block" *ngFor="let product of products">
        <app-collection-item
          class="action"
          [product]="product"
          [routerLink]="['/products/', product.handle]"
        ></app-collection-item>
      </div>
    </app-carousel>
  </div>
</div>
